export * from './collapse-all-league';